const mapStateToProps = state => ({
    userId: state.userId,
    authToken: state.authToken,
    customView: state.customView
});

export default mapStateToProps;